import React from 'react';
import PropTypes from 'prop-types';

import { Link } from '@zola/zola-ui';

const EventFormSuggestions = props => {
  const {
    rsvpSuggestions,
    suggestedAttireOptions,
    isAttire,
    isCommonQs,
    setAttire,
    setQuestion,
    onToggleCommonQs,
    onToggleAttireOs,
  } = props;

  let suggestionType;
  let suggestions;
  let setSuggestion;
  let toggleSuggestions;

  if (isAttire && suggestedAttireOptions) {
    suggestionType = 'attire';
    suggestions = suggestedAttireOptions;
    toggleSuggestions = onToggleAttireOs;
    setSuggestion = attire => setAttire(attire);
  }

  if (isCommonQs && rsvpSuggestions) {
    suggestionType = 'question';
    suggestions = rsvpSuggestions;
    toggleSuggestions = onToggleCommonQs;
    setSuggestion = question => setQuestion(question);
  }

  return (
    <div className="event-form__suggestions">
      {/* <span className="text-button back-button" onClick={toggleSuggestions}>
        &lsaquo; back
      </span> */}
      <Link
        className="back-button"
        arrow
        size="smaller"
        role="button"
        arrowPosition="prefix"
        onClick={toggleSuggestions}
      >
        Back
      </Link>
      <ul className={`suggestion-list list-unstyled -${suggestionType}`}>
        {suggestions &&
          suggestions.map((suggestion, idx) => (
            <li
              className={`suggestion common-${suggestionType}`}
              onClick={() => {
                setSuggestion(suggestion);
                toggleSuggestions();
              }}
              key={idx}
              role="button"
            >
              <div className="suggestion__text">{suggestion[suggestionType]}</div>
              <span className="suggestion__select text-button">Select &rsaquo;</span>
            </li>
          ))}
      </ul>
    </div>
  );
};

EventFormSuggestions.propTypes = {
  suggestedAttireOptions: PropTypes.arrayOf(PropTypes.shape({})),
  rsvpSuggestions: PropTypes.arrayOf(PropTypes.shape({})),
  isAttire: PropTypes.bool,
  isCommonQs: PropTypes.bool,
  setAttire: PropTypes.func,
  setQuestion: PropTypes.func,
  onToggleCommonQs: PropTypes.func,
  onToggleAttireOs: PropTypes.func,
};

export default EventFormSuggestions;



// WEBPACK FOOTER //
// ./src/components/manage/common/EventForm/EventFormSuggestions.jsx